export const learningRoutePaths = {
  HOME: '/learning',
  COURSES: '/learning/courses',
  ADMIN: '/learning/admin',
  CONFIRMATION: '/learning/confirmation',
} as const;
